import { getChatbotEnv } from '../utils/session-storage-utils';

const accountId = 'ozoDdrmewShEcbUDWX8J3V';

export const API_ENDPOINTS = {
  GCP: 'https://global-channel-provider-service.care.vpsvc.com',
  DESIGN_ARTICLES: 'https://design-help-articles.care.vpsvc.com',
  USER_PROFILE: `https://profile.cimpress.io/v1/${accountId}/profile/me`,
  VP_MERCHANT: 'https://vpmerchant.dsp.dst.vpsvc.com/v1',
  CHATBOT_BASE_URL: (): string => {
    const env = getChatbotEnv();
    if (env === 'staging') return 'https://chatbot-careai.stg.careai.vpsvc.com';
    if (env === 'dev') return 'https://chatbot-careai.dev.careai.vpsvc.com';
    return 'https://chatbot-genai.prod.careai.vpsvc.com';
  },
  CONCORD_BASE_URL: (): string => {
    const env = getChatbotEnv();
    if (env === 'dev') return 'https://care-concord-service.dev.careai.vpsvc.com/api/v1/internal';
    return 'https://care-concord-service.prod.careai.vpsvc.com/api/v1/internal';
  },
  TRANSLATIONS: (locale: string): string => `https://chat-anywhere.care.vpsvc.com/chatbot/translations/${locale}-translations.json`,
  SF_CONFIG: (locale: string): string => `https://chat-anywhere.care.vpsvc.com/chatbot/sf-config/${locale}.json`,
  ATTACHMENT_IMAGE: 'https://chat-anywhere.care.vpsvc.com/chatbot/assets/miaw-attachment.png',
  PAGE_CONFIG: `https://chat-anywhere.care.vpsvc.com/chatbot/page-config/banner-pages.json`,
  CLOUDINARY_BASE_URL: 'https://cms.cloudinary.vpsvc.com/image/upload',
  NOTIFICATION_SOUND: 'https://dqq742lm0w7m1.cloudfront.net/JS-build/notification.wav',
  CHATBOT_CONFIG: `https://chat-anywhere.care.vpsvc.com/chatbot/chatbot-config.json`,
  BANNER_CONFIG: `https://caretech-ux-mods-prod.s3.amazonaws.com/hurricane-banner-config.json`,
  SNEAK_PEAK_WS_URL: (): string => {
    const env = getChatbotEnv();
    if (env === 'dev') return 'wss://sneak-peek.dev.careai.vpsvc.com';
    if (env === 'staging') return 'wss://sneak-peek.dev.careai.vpsvc.com';
    return 'wss://sneak-peek.prod.careai.vpsvc.com';
  },
};
